<template>
  <div
    id="footer"
    class="footer"
    data-testid="copyright-footer"
  >
    <ul class="footer-links list-inline text-regular">
      <li class="list-inline-item">
        <a :href="`http://www.${$DEFAULT_HOST}/terms-of-service`">{{ $t("element.copyrightFooter.terms") }}</a>
      </li>
      <li class="list-inline-item">
        <a :href="`http://www.${$DEFAULT_HOST}/privacy`">{{ $t("element.copyrightFooter.privacy") }}</a>
      </li>
      <li class="list-inline-item">
        <span
          class="copyright"
          data-testid="copyright"
        >
          {{ $options.COPYRIGHT_TEXT }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { COPYRIGHT_TEXT } from 'client/modules/constants'

export default {
  COPYRIGHT_TEXT
}
</script>
